<script>
export default {
  name: "AdvancedRubricPreviewTable",
  props: {
    criteria: {
      type: Array,
      required: true,
    },
  },
  computed: {
    gradesMaxCount() {
      return this.criteria.reduce((a, c) => Math.max(a, c.scales.length), 0);
    },
  },
};
</script>

<template>
  <eg-b-table-simple striped hover responsive outlined>
    <eg-b-thead class="caption-s">
      <eg-b-tr>
        <eg-b-th>{{ $t("rubrics.gradingCriteria") }}</eg-b-th>
        <eg-b-th>{{ $t("rubrics.criteriaAndDescriptors") }}</eg-b-th>
      </eg-b-tr>
    </eg-b-thead>
    <eg-b-tbody class="paragraph-s">
      <eg-b-tr v-for="criterion in criteria" :key="criterion.id">
        <eg-b-td class="criteria-name-col">{{ criterion.point }}</eg-b-td>
        <eg-b-td
          class="criteria-description-col"
          :style="{
            'grid-template-columns': `repeat(${gradesMaxCount}, minmax(150px, 1fr))`,
          }"
        >
          <template v-for="(scale, idx) in criterion.scales">
            <span :key="idx.toString() + 'g'">
              <b>{{ scale.scale }}</b>
              <span v-if="scale.title"> ({{ scale.title }}) </span>
            </span>

            <p :key="idx.toString() + 'd'" style="white-space: pre-line">
              {{ scale.description }}
            </p>
          </template>
        </eg-b-td>
      </eg-b-tr>
    </eg-b-tbody>
  </eg-b-table-simple>
</template>

<style scoped>
.criteria-description-col {
  display: inline-grid;
  grid-template-rows: repeat(2, auto);
  grid-auto-flow: column;
  grid-gap: 1rem;
}
.criteria-name-col {
  min-width: 150px;
}
</style>
